import { DefaultParams } from '@/api/bbsworld/default';
import { request } from '@/api/client';
import { Device } from '@/classes/Device';
import { RequestFailedError } from '@/classes/Error';
import { API_URL, API_VERSION, SECOND_MS } from '@/constants';
import { Resource } from '@/types';
import { stringify } from 'qs';

const HTTP_STATUS_NO_CONTENT = 204;

// ! 구형 기기(webOS 4.0/4.5)는 첫 로드가 느려 기본 10초로는 시간 초과가 난다.
const INITIAL_LOAD_TIMEOUT_MS = 30 * SECOND_MS;

export type GetResourcesParams = DefaultParams;

export async function getResources(params: GetResourcesParams): Promise<Resource> {
  const data = await request<Resource>({
    url: `${API_URL}/api/${API_VERSION}/resources?${stringify({ deviceId: Device.uuid, ...params })}`,
    init: { method: 'GET', credentials: 'include' },
    timeoutMs: INITIAL_LOAD_TIMEOUT_MS,
  });

  if (!data) {
    throw new RequestFailedError(HTTP_STATUS_NO_CONTENT);
  }

  return data;
}
